module.exports = __webpack_public_path__ + "img/videoPlayer_poster.de869862.gif";